import { createApiSlice } from '@/shared/features/query/config/query.build';
import type { ReduxQueryClient } from '@/shared/features/query/domain/interfaces/QueryClient';

interface PropertyApiResponse {
  hasError: boolean;
  properties?: Record<string, string>;
  message?: string;
}

const bsUtilApiSlice = createApiSlice({
  clientId: 'bsUtilApi',
  tagTypes: ['BsUtil'],
  endpoints: {
    getHomePageVariantProperty: {
      url: '/bs-util/property?names=NEW_HOME_PAGE_PERCENTAGE',
      method: 'GET',
      transformResponse: (response: unknown): number => {
        const dto = (typeof response === 'object' && response !== null ? response : {}) as PropertyApiResponse;
        if (dto.hasError || !dto.properties) return 0;
        const raw = dto.properties['NEW_HOME_PAGE_PERCENTAGE'];
        if (raw === undefined || raw === null) return 0;
        const parsed = Number(raw);
        if (!Number.isFinite(parsed)) return 0;
        return Math.min(100, Math.max(0, parsed));
      },
      providesTags: ['BsUtil'],
    },
  },
});

export const bsUtilApi = bsUtilApiSlice.queryClient;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hooks = bsUtilApiSlice.hooks as any;
export const useGetHomePageVariantPropertyQuery = hooks?.useGetHomePageVariantPropertyQuery;

export const bsUtilApiRedux = bsUtilApiSlice.queryClient as ReduxQueryClient;

export default bsUtilApiSlice;
